import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import useModal from "@rf/base/modal/useModal";
import MxFileViewer from "../components/l1/file-viewer/MxFileViewer";
import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";

interface IShowFileModal {
  url: string;
  dateMsg?: string;
}
const useShowFileModal = () => {
  const { modal } = useModal();

  const showFileModal = (data: IShowFileModal) => {
    modal({
      data: data,
      template: <MxModalTemplate2 children={<ModalTemplate />} />,
      options: {
        style: {
          width: "100%",
          maxWidth: 700,
          height: "100%",
          maxHeight: 600,
          padding: 10
        },
        title: ""
      }
    });
  };
  return {
    showFileModal
  };
};

export default useShowFileModal;

const ModalTemplate = () => {
  const { getData } = useModal();
  const data = getData() as IShowFileModal;
  return (
    <Grid container rowGap={1}>
      <Grid item xs={12}>
        <MxFileViewer url={data.url} />
      </Grid>
      {data?.dateMsg && (
        <Grid item xs={12}>
          <MxTypography color="grey" variant="overline" >
            {data.dateMsg}
          </MxTypography>
        </Grid>
      )}
    </Grid>
  );
};
